export default __webpack_public_path__ + "static/media/promission-overview.6ce85bb0.png";